import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap, filter } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { FirmSelectionService, selectedFirmName } from '../../firm-selection.service';
import { ApiService } from '../../api.service';

@Injectable({
  providedIn: 'root'
})
export class StockInService {
  private apiUrl = environment.apiBaseUrl;

  constructor(
    private http: HttpClient,
    private firmSelectionService: FirmSelectionService,
    private apiService: ApiService,
  ) {}

  /**
   * Get all Stock In entries reactively based on the selected firm.
   */
  getStockInEntries(params?: HttpParams): Observable<any> {
    return this.firmSelectionService.selectedFirmName$.pipe(
      filter((firm): firm is selectedFirmName => !!firm), // only proceed if firm is selected
      switchMap(firm => {
        let updatedParams = params || new HttpParams();
        updatedParams = updatedParams.set('firm_id', firm.id.toString());
        return this.apiService.get('stock_ins', updatedParams);
      })
    );
  }
}
